import { state } from 'cerebral';
import { INDICATOR } from 'resources/constants';

export function resetShowMoreInfo({ store }) {
  for (const indicator of Object.values(INDICATOR)) {
    store.set(state`challenge.activityModal.showMoreInfo.${indicator}`, false);
  }
}
